import { userIsDoNotShareSellTA } from '@/features/account/services/DataPrivacy/utils'
import { type ValidAddress } from '@/features/account/services/Addresses/types'
import { useMutationHandleOptOutRestrictions } from '@/features/account/services/DataPrivacy/mutations'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { persistGuestAddress } from '@/features/account/services/GuestUser/utils'

export const useMutationSetGuestAddressCookie = () => {
  const queryClient = useQueryClient()
  const { mutateAsync: handleOptOutRestrictions } = useMutationHandleOptOutRestrictions()

  return useMutation({
    mutationFn: async (address: ValidAddress) => {
      await Promise.all([
        persistGuestAddress(address, queryClient),
        userIsDoNotShareSellTA()
          ? Promise.resolve(undefined)
          : handleOptOutRestrictions({
              state: address.state,
              zip_code: address.zip_code,
              // a failed lookup is already handled by the restrictions mutation's onError (it
              // records a conservative opt-out), so it must not block or fail saving the address
            }).catch(() => undefined),
      ])
    },
  })
}
